export default function VenuesSection({ city, t }) {
  const bg = city.venuesBg || `/weddings/${city.slug}/venues-bg.webp`;
  return (
    <section className="relative bg-[#0A0807] py-16 sm:py-24 lg:py-32 overflow-hidden" data-testid="weddings-venues">
      <div className="absolute inset-0">
        <img
          src={bg}
          alt=""
          aria-hidden="true"
          className="absolute inset-0 w-full h-full object-cover scale-105"
          style={{ filter: "blur(4px) brightness(0.7) saturate(1.15)" }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A0807]/65 via-[#0A0807]/35 to-[#0A0807]/75" />
      </div>
      <div className="absolute inset-0 opacity-[0.05] pointer-events-none"
           style={{ backgroundImage: "radial-gradient(#D4B896 0.5px, transparent 0.5px)", backgroundSize: "26px 26px" }} />

      <div className="relative max-w-[1400px] mx-auto px-5 sm:px-10">
        <div className="text-center mb-12 sm:mb-16">
          <p className="text-[10px] sm:text-[11px] tracking-[0.3em] sm:tracking-[0.35em] text-[#F5C77A] mb-3 sm:mb-4 font-light">{t.venuesEyebrow}</p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl text-white leading-tight" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 400 }}>
            {t.venuesTitle}
          </h2>
          <p className="text-sm sm:text-base text-white/70 font-light mt-4 sm:mt-5 max-w-2xl mx-auto leading-relaxed">{t.venuesSubtitle}</p>
          <div className="w-12 sm:w-16 h-px bg-[#F5C77A] mx-auto mt-5 sm:mt-6" />
        </div>

        <div className="flex flex-wrap justify-center gap-2.5 sm:gap-3 max-w-4xl mx-auto">
          {city.venues.map(v => (
            <span key={v} className="inline-block px-4 sm:px-5 py-2 sm:py-2.5 bg-white/[0.06] backdrop-blur-md border border-white/15 text-white text-xs sm:text-sm font-light hover:bg-[#F5C77A]/15 hover:border-[#F5C77A]/60 hover:text-[#F5C77A] transition cursor-default rounded-sm">
              {v}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
